import { createEvent, sample } from 'effector'
import { register } from '~/core/repository'
import { model as router } from '~/core/router'
import { model as accountSettingsFeatureModel } from '~/features/account-settings'

export const init = createEvent()
export const left = createEvent()

const backToSettings = createEvent()

sample({
  clock: backToSettings,
  fn: () => '/modules/settings',
  target: router.navigatePush,
})

// Initialize account settings feature
sample({
  clock: init,
  target: accountSettingsFeatureModel.init,
})

// Reset account settings feature when leaving page
sample({
  clock: left,
  target: accountSettingsFeatureModel.left,
})

register(backToSettings, 'settings/account/backToSettings')
